import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { HeadingSizeType } from '../../../../../components/Atoms/Heading/Heading.enum';
import { TagColorVariant } from '../../../../../components/Molecules/Tag/Tag.enum';
import sendGTMEvent from '../../../../common/analytics/sendGTMEvent';
import { StyledHeading } from '../../Autocomplete.styled';
import { StyledDropdownContent, StyledTag, StyledTagsContainer, } from './MostPopularSearches.styled';
export const MostPopularSearches = ({ handleClick, mostPopularSearches, phrase, hasRecentlySearchItems, }) => {
    const handleOnMostPopularClick = ({ index, item }) => {
        sendGTMEvent({
            event: 'search_perform',
            search_term: item && item.toLowerCase(),
            search_input: phrase ? phrase.toLowerCase() : '(empty_input)',
            search_method: 'recommendation',
            search_category: '',
        });
        handleClick &&
            handleClick({
                searchPhrase: phrase,
                category: '',
                listingFunction: 'most_popular',
                listingType: 'autocomplete',
                phrase: item,
                searchPosition: index,
            });
    };
    const Container = hasRecentlySearchItems ? Fragment : StyledDropdownContent;
    return (mostPopularSearches === null || mostPopularSearches === void 0 ? void 0 : mostPopularSearches.length) ? (_jsxs(Container, { children: [_jsx(StyledHeading, Object.assign({ as: "h5", hasRecentlySearchItems: hasRecentlySearchItems, textSize: HeadingSizeType.TITLE16 }, { children: "Popular searches" }), void 0), _jsx(StyledTagsContainer, { children: mostPopularSearches.map((item, index) => (_jsx(StyledTag, Object.assign({ onClick: () => handleOnMostPopularClick({ index, item }), role: "link", variant: TagColorVariant.GREY }, { children: item }), item))) }, void 0)] }, void 0)) : null;
};
//# sourceMappingURL=MostPopularSearches.js.map